import { render, staticRenderFns } from "./LicensesTable.vue?vue&type=template&id=ea690484&scoped=true&"
import script from "./LicensesTable.vue?vue&type=script&lang=js&"
export * from "./LicensesTable.vue?vue&type=script&lang=js&"
import style0 from "./LicensesTable.css?vue&type=style&index=0&id=ea690484&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea690484",
  null
  
)

export default component.exports